export const clearDependentFields = (
  changedField: string,
  onValueChange: (field: string, value: any) => void
) => {
  switch (changedField) {
    case "carMaker":
      onValueChange("modelLine", "");
      onValueChange("year", "");
      onValueChange("modification", "");
      break;
    case "modelLine":
      onValueChange("year", "");
      onValueChange("modification", "");
      break;
    case "year":
      onValueChange("modification", "");
      break;
    default:
      break;
  }
};
